import React, { memo } from 'react';
import type { ReactNode } from 'react';
import cc from 'classcat';
import './verticalLayout.css';

export interface VerticalLayoutProps {
  className?: string;
  children?: ReactNode;
}

const VerticalLayout = ({ children, className }: VerticalLayoutProps) => {
  if (!children) return null;

  return (
    <div className={cc(['verticalLayout__content hide-scrollbar', className])} role="list">
      {children}
    </div>
  );
};

export default memo(VerticalLayout);
